




























import { TargetTrackerRequest } from '@/api/requests/target-tracker/target-tracker-request';
import { Forbidden } from '@/api/responses/forbidden';
import { TargetTrackerApi } from '@/api/target-tracker';
import loading from '@/components/loading.vue';
import targetTrackerAdvisorTab from '@/components/target-tracker/target-tracker-advisor-tab.vue';
import targetTrackerDetailTable from '@/components/target-tracker/target-tracker-detail-table.vue';
import targetTrackerFilters from '@/components/target-tracker/target-tracker-filters.vue';
import targetTrackerOverviewTable from '@/components/target-tracker/target-tracker-overview-table.vue';
import { TargetTrackerAdvisor } from '@/shared/target-tracker-advisor';
import { TargetTrackerOverview } from '@/shared/target-tracker-overview';
import { Component, Vue, Watch } from 'vue-property-decorator';

const targetTrackerApi = new TargetTrackerApi();

@Component({
    components: {
        targetTrackerAdvisorTab,
        targetTrackerFilters,
        targetTrackerDetailTable,
        targetTrackerOverviewTable,
        loading,
    },
})
export default class TargetTracker extends Vue {
    private isLoading: boolean = true;
    private tabIndex: number | null = 0;
    private request: TargetTrackerRequest | null = null;
    private targets: Array<TargetTrackerOverview> = new Array<TargetTrackerOverview>();
    private selectedAdvisor: TargetTrackerAdvisor | null = null;

    private get legalAdvisors(): Array<{ id: string, name: string }> {
        if (!this.targets.length) { return []; }

        return this.targets.map((target) => {
            const initial = target.firstName == null ? '' : target.firstName.trim().charAt(0);
            const lastName = target.lastName == null ? '' : target.lastName.trim();

            return {
                id: target.id!,
                name: target.id === '00000000-0000-0000-0000-000000000000' ? target.firstName!.trim() : `${initial}.${lastName}`,
            };
        });
    }

    @Watch('tabIndex')
    private async onTabIndexChanged(tabIndex: number): Promise<void> {
        if (tabIndex === 0) {
            await this.loadTargetsAsync();
            return;
        }
    }

    private async onFilterAsync(request: TargetTrackerRequest): Promise<void> {
        this.request = request;
        await this.loadTargetsAsync();
    }

    private async loadTargetsAsync(): Promise<void> {
        if (this.request == null) { return; }

        try {
            this.isLoading = true;

            this.targets = await targetTrackerApi.getTargetTrackerOverviewAsync(this.request);
            this.tabIndex = 0;
            this.selectedAdvisor = null;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not load legal advisor targets. Please try again.`, type: 'is-danger' });
            }
        }

        this.isLoading = false;
    }

    private async onUserTabClicked(legalAdvisorId: string) {
        try {
            this.selectedAdvisor = await targetTrackerApi.getTargetTrackerDetailsAsync(legalAdvisorId, this.request!);
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not load legal advisor targets. Please try again.`, type: 'is-danger' });
            }
        }
    }

    private async reloadUserAsync(legalAdvisorId: string): Promise<void> {
        await this.onUserTabClicked(legalAdvisorId);
    }

    private async mounted(): Promise<void> {
        this.isLoading = true;

        await Promise.all([
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`users/loadAllUsersAsync`),
        ]);

        this.isLoading = false;
    }
}
